import React, { useState, FC } from 'react'
import { InputGroup, InputProps, InputRightElement } from '@chakra-ui/react'

import Input from '../Input/Input'
import type { BasicComponentProps } from '../../common/types'
import { NucEye, NucEyeClose } from '../../icons'

const PasswordInput: FC<BasicComponentProps<InputProps>> = ({
  variant,
  ...rest
}) => {
  const [show, setShow] = useState(false)

  return (
    <InputGroup display='inline-block' w='auto'>
      <Input
        type={show ? 'text' : 'password'}
        variant={variant}
        pr='2.5rem'
        {...rest}
      />

      <InputRightElement
        pos='absolute'
        width='3rem'
        onClick={() => setShow(!show)}
        _hover={{ cursor: 'pointer' }}
      >
        {show ? <NucEyeClose /> : <NucEye />}
      </InputRightElement>
    </InputGroup>
  )
}

export default PasswordInput
